module.exports = __webpack_public_path__ + "img/ui.ebd03ea0.png";